import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificate-detail',
  templateUrl: './certificate-detail.component.html',
  styleUrls: ['./certificate-detail.component.scss']
})
export class CertificateDetailComponent implements OnInit {

  @Input() certificate: any;

  constructor() { }

  ngOnInit() { }

}
